// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//  import VueStripeCheckout from 'vue-stripe-checkout'

Vue.config.productionTip = false
//  test pk_test_OlQ8pK9OWiWKOYIlWXBMuMxT
const options = {
  //  key: 'pk_test_OlQ8pK9OWiWKOYIlWXBMuMxT',
  image: 'http://oncenature.org/img/paybild.png',
  locale: 'auto',
  currency: 'USD',
  billingAddress: false,
  panelLabel: 'Donate {{amount}}'
}
console.log(options)
//  Vue.use(VueStripeCheckout, options)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js